"use client";

import dynamic from "next/dynamic";

export const SpeechWrapper = dynamic(() => import("./Speech").then(mod => mod.Speech));
